import React, {
	useMemo, useState, useEffect,
} from 'react';
import { useSelector } from 'react-redux';
import Icon, { ICONS, COLORS } from '../general-components/icon';
import { GreenroomState as GRS } from '../../stores/types/types';
import { showAlert } from '../general-components/alert-service';
import { parseBitrate } from '../../utils/utils';

interface Props {
	feedWebRtcId: string;
}

export default function FeedDebugOverlay(props: Props) {
	const {
		feedWebRtcId,
	} = props;

	const webrtcID = useSelector((s: GRS) => s.SessionReducer.webrtcID);
	const meeting = useSelector((s: GRS) => s.SessionReducer.meeting);
	const openTokStats = useSelector((s: GRS) => s.OpenTokReducer.openTokStats);
	const showDebugUI = useSelector((s: GRS) => s.OpenTokReducer.showDebugUI);

	const copyOpentokData = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		const { guid } = openTokStats[feedWebRtcId];
		event.stopPropagation();
		navigator.clipboard.writeText(`${meeting?.opentok_session}\nGUID: ${guid}`);
		showAlert({
			message: 'Copy Successful',
			description: 'Video troubleshooting information copied.',
			duration: 2000,
		});
		event.currentTarget.blur();
	};

	return (<>
		{showDebugUI && openTokStats[feedWebRtcId] && (
			<div className="debug-ui">
				<div className="display-flex">
					<span>{openTokStats[feedWebRtcId].frameRate.toFixed(1)}fps</span>
					<span className="margin-left-small">
						<Icon
							name={webrtcID === feedWebRtcId ? ICONS.ARROW_UP : ICONS.ARROW_DOWN}
							color={COLORS.WHITE}
							size={10}
						/>
						{parseBitrate(openTokStats[feedWebRtcId].videoBitrate, false)
							? parseBitrate(openTokStats[feedWebRtcId].videoBitrate, false)
							: '0kbps'
						}
					</span>
				</div>
				<span>{openTokStats[feedWebRtcId].videoPacketLossRatio.toFixed(1)}%</span>
				<div className="flex-align-center justify-content-space-between">
					<span>
						{
							openTokStats[feedWebRtcId].resolution.width
								&& openTokStats[feedWebRtcId].resolution.height
								? `${openTokStats[feedWebRtcId].resolution.width}x${openTokStats[feedWebRtcId].resolution.height}`
								: null
						}
					</span>
					<button onClick={copyOpentokData}>
						<Icon name={ICONS.COPY_FILLED} color={COLORS.WHITE} size={14} />
					</button>
				</div>
			</div>
		)}
	</>);
}
